module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Image-a8eebedee05811996a8b3388469bb873.svg";